import type { DeviceChangeBadgeProps } from 'Modules/softphone/components/SoftphoneDevTools/DeviceChangeBadge/index.types';
import { DEVICE } from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DeviceChangeBadge - Which device a change was about
 *
 * The channel badge would say DEV on all three, which is the one thing a
 * reader of this list already knows. The device kind is what separates the
 * rows, so it gets the badge — and the colour it carries in the lanes, so the
 * two readings of the same change look like the same change.
 */
export const DeviceChangeBadge: React.FC<DeviceChangeBadgeProps> = ({
  type,
}) => (
  <span
    className={cn(
      'inline-flex flex-shrink-0 items-center rounded border px-[5px] py-0.5 font-sp-mono text-[9px] font-bold uppercase tracking-[0.06em]',
      DEVICE[type].chip
    )}
  >
    {DEVICE[type].label}
  </span>
);
